import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";
import {CfConfigPage} from "../page/overview/cf-config/cf-config.page";


const cfModuleEntry: TestModuleDefinition = {
    key: 'cf',
    label: 'Calculation (cf)',
    components: [
        {
            key: 'CfConfigPage',
            component: CfConfigPage,
            selector: 'mvs-cf-config',
            type: 'PageComponent',
            label: 'mvs cf config'
        },
    ]
}

export const CF_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: cfModuleEntry, multi: true}
];